class room {
    constructor(options) {
        this.id = options.id;
        this.type = options.type;
        this.name = options.name;
        this.unreadCount = options.unreadCount ? options.unreadCount : 0;
        this.isReadOnly = options.isReadOnly ? options.isReadOnly : false;
        this.announcement = options.announcement;
        this.messageClearTime = options.messageClearTime;
        this.messageSendTime = undefined;
        this.onTalkTime = undefined;
        this.groupReadOnly = options.groupReadOnly ? options.groupReadOnly : false;

        // 全站群聊的設定
        this.image = options.image;
        this.description = options.description;
        this.hasPassword = options.hasPassword ? options.hasPassword : false;
        this.startTutorTalking = options.startTutorTalking ? options.startTutorTalking : false;
    }
}

class roomMember {
    constructor(options) {
        this.userId = options.userId;
        this.nickName = options.nickName;
        this.loginId = options.loginId;
        this.isOnline = options.isOnline;
        this.isChatDenied = options.isChatDenied;
        this.role = options.role;
        this.userLevel = options.userLevel;
        this.headImage = options.headImage;
        this.isReadOnly = options.isReadOnly;
    }
}

class roomMemberContainer {
    constructor(options) {
        this.room = options.room;
        this.roomMembers = options.roomMembers;
    }
}

class roomListClassification {
    constructor(options) {
        this.name = options.name;
        this.roomType = options.roomType;
        this.rooms = options.rooms;
    }
}

class roomMessage {
    constructor(options) {
        this.messageId = options.messageId;
        this.userId = options.userId;
        this.name = options.name;
        this.type = options.type;
        this.content = options.content;
        this.timestamp = options.timestamp;
        this.userLevel = options.userLevel;
        this.headImage = options.headImage;
    }
}

class roomMessageContainer {
    constructor(options) {
        this.room = options.room;
        this.roomMessages = options.roomMessages;
    }
}

class roomWindow {
    constructor(options) {
        this.room = options.room;
        this.showTime = options.showTime;
    }
}

class roomLastMessage {
    constructor(options) {
        this.room = options.room;
        this.userId = options.userId;
        this.name = options.name;
        this.type = options.type;
        this.content = options.content;
        this.timestamp = options.timestamp;
    }
}

class roomWindowSize {
    constructor(options) {
        this.room  = options.room;
        this.height = options.height;
        this.width = options.width;
        this.date = options.date;
    }
}

class siteGroupRoom {
    constructor(options) {
        this.room = options.room;
        this.isReadOnly = options.isReadOnly;
        this.systemMessage = options.systemMessage;
        this.readOnlyHint = options.readOnlyHint;
        this.enteringUserName = null;
        this.followBet = null;
        this.isTutor = options.isTutor;
        this.pinMessageId = options.pinMessageId;
    }
}

class tutor {
    constructor(options) {
        this.roomId = options.roomId;
        this.name = options.name;
        this.headImage = options.headImage;
    }
}

export {
    room,
    roomMember,
    roomMemberContainer,
    roomListClassification,
    roomMessage,
    roomMessageContainer,
    roomWindow,
    roomLastMessage,
    roomWindowSize,
    siteGroupRoom,
    tutor,
};
